<template>
  <div class="contratos">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" :label="$t('Listado de contratos')">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form onsubmit="return false;" label-position="top">
              <el-form-item label="Búsqueda avanzada">
                <el-input :placeholder="$t('Búsqueda por nombre de contrato')" prefix-icon="el-icon-search"
                  v-model="search" size="medium" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="3">
            <el-form onsubmit="return false;" label-position="top">
              <el-form-item label="Tipo de contrato">
                <el-select @change="resetListado" class="tipoContrato" size="medium" v-model="tipo"
                  placeholder="Seleccione tipo">
                  <el-option v-for="item in options" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col v-if="tipo === 'Contratista'" :span="3">
            <el-form onsubmit="return false;" label-position="top">
              <el-form-item label="Seleccione estado">
                <el-select @change="resetListado" class="tipoContrato" size="medium" v-model="estado"
                  placeholder="Seleccione estado">
                  <el-option v-for="item in estados" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col v-if="tipo === 'Contratista'" :span="3">
            <el-form onsubmit="return false;" label-position="top" style="text-align: center;">
              <el-form-item label="Sub-contratos">
                <el-switch v-model="subcontrato" @change="setSubcontrato">
                </el-switch>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col v-if="subcontrato === true" :span="5">
            <el-form onsubmit="return false;" label-position="top">
              <el-form-item label="Seleccione empresa mandante">
                <el-select filterable @change="setMandante" size="medium" v-model="empresa_mandante"
                  placeholder="Seleccione estado">
                  <el-option label="Todas las empresas" :value="null"></el-option>
                  <el-option v-for="item in subcontratistas" :key="item.subcontrato_empresa_id" :label="item.empresa"
                    :value="item.subcontrato_empresa_id"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="4">
            <el-form onsubmit="return false;" label-position="top" v-if="!$store.getters.user.readonly">
              <el-form-item label="">
                <br />
                <el-button size="medium" type="primary" @click="createContract()" icon="el-icon-edit">
                  {{ $t("Nuevo Contrato") }}
                </el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <center v-if="loading">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-row v-else>
          <el-table :max-height="700" class="contractsTable" :data="paginar === false ? contracts : paginarContratos()"
            row-class-name="rowClassTablaPloma" cell-class-name="cellClassTablaPloma"
            header-cell-class-name="header-cell-class-table-gray">
            <el-table-column v-if="tipo === 'Contratista'" align="center" prop="subcontrato" min-width="100px" :label="$t('Sub-contrato')">
              <template slot-scope="scope">
                <i class="el-icon-remove" v-if="scope.row.subcontrato === false || !scope.row.subcontrato"
                  style="color: gray; font-size: 25px !important"></i>
                <i class="el-icon-success" v-else
                  style="color: green; font-size: 25px !important"></i>
              </template>
            </el-table-column>
            <el-table-column :label="$t('Área')" min-width="150px" sortable>
              <template slot-scope="scope">
                {{
        scope.row.data_area
          ? scope.row.data_area.nombre
          : "Área no encontrada"
      }}
              </template>
            </el-table-column>
            <el-table-column v-if="tipo !== 'Propio'" :label="$t('Empresa')" min-width="150px" sortable>
              <template slot-scope="scope">
                <p v-if="scope.row.tipo_contrato === 'Propio'" class="text-muted">
                  No aplica
                </p>
                <p v-else>
                  {{
        scope.row.data_empresa
          ? scope.row.data_empresa.nombre
          : "Empresa no encontrada"
      }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="nombre" min-width="170px" :label="$t('Nombre del contrato')" sortable />
            <el-table-column prop="numero_contrato" width="130px" :label="$t('N° Contrato')" sortable />
            <el-table-column align="center" width="100px" :label="$t('Estado')">
              <template slot-scope="scope">
                <span :class="[
        'safety-tag',
        isActiveContract(scope.row) ? 'green' : 'red',
      ]">{{
        isActiveContract(scope.row) ? $t("Vigente") : $t("Vencido")
      }}</span>
              </template>
            </el-table-column>
            <el-table-column width="180px" label="Opciones" align="center" v-if="!$store.getters.user.readonly">
              <template slot-scope="scope">
                <center>
                  <el-button style="margin-left: 0px; width: 100%" @click="elegirContrato(scope.row)" size="small"
                    icon="el-icon-edit-outline" type="primary">{{ $t("Modificar") }}</el-button>
                  <el-button style="margin-left: 0px; width: 100%; margin-top: 10px"
                    @click="eliminarContrato(scope.row)" v-if="[
        '642198cb8c03c500123c0d94',
        '655ca26350599500126cc6e2',
        '5e41686693114800178f246f',
        '608c08fc3fdf700017e11c95',
        '5b929a761616050010f76dff',
        '59cbfb0c0a1d7d0011ba7860',
      ].includes($store.getters.user._id)
        " size="small" icon="el-icon-delete" type="danger">{{ $t("Eliminar") }}</el-button>
                  <el-button style="margin-left: 0px; width: 100%; margin-top: 10px"
                    @click="duplicarContrato(scope.row)" v-if="isActiveContract(scope.row) &&
        [
          '642198cb8c03c500123c0d94',
          '655ca26350599500126cc6e2',
          '5e41686693114800178f246f',
          '608c08fc3fdf700017e11c95',
          '5b929a761616050010f76dff',
          '59cbfb0c0a1d7d0011ba7860',
        ].includes($store.getters.user._id)
        " size="small" icon="el-icon-document" type="info">{{ $t("Duplicar") }}</el-button>
                  <!-- <el-button
                    v-if="!isActiveContract(scope.row)"
                    style="margin-left: 0px; width: 100%; margin-top: 10px"
                    @click="seleccionarContratoVigencia(scope.row)"
                    size="small"
                    icon="el-icon-edit-outline"
                    type="primary"
                    >{{ $t("Actualizar Vigencia") }}</el-button
                  > -->
                </center>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <br />
          <center>
            <el-pagination :current-page="page" @prev-click="backPage" @next-click="nextPage"
              @current-change="currentPage" :page-size="5" layout="prev, pager, next"
              :total="totalPage"></el-pagination>
          </center>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <!--Dialog editar-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" top="3vh" :before-close="handleClose" :title="`Modificando Contrato`" :visible="editarVisible"
      width="65%">
      <div class="content_edit">
        <ModificarContrato :contract="contract" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editarVisible = false">Cerrar</el-button>
        <el-button :loading="isLoading" @click="updateContract()" type="primary">Modificar</el-button>
      </span>
    </el-dialog>

    <el-dialog :before-close="handleClose" :title="`Modificando Vigencia del Contrato`" :visible="editarFechasVisible"
      width="30%">
      <div class="content_edit">
        <el-row>
          <el-col :md="24">
            <br />
            <div class="title">
              <b>{{ $t("Fecha inicio") }}</b>
            </div>
            <el-date-picker class="full-width" type="date" size="medium" placeholder="Ingrese fecha de inicio"
              v-model="contract['fecha_inicio']"></el-date-picker>
          </el-col>
          <el-col :md="24">
            <br />
            <div class="title">
              <b>{{ $t("Fecha fin") }}</b>
            </div>
            <el-date-picker class="full-width" type="date" size="medium" placeholder="Ingrese fecha fin"
              v-model="contract['fecha_fin']"></el-date-picker>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editarFechasVisible = false">Cerrar</el-button>
        <el-button :loading="isLoading" @click="updateContract()" type="primary">Modificar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import ModificarContrato from "@/components/EditarContrato.vue";
import axios from "axios";

export default {
  name: "Contracts",
  data() {
    return {
      empresa_mandante: null,
      subcontratistas: [],
      subcontrato: false,
      tipo: "Propio",
      options: [
        {
          value: "Propio",
          label: "Propio",
        },
        {
          value: "Contratista",
          label: "Contratista",
        },
      ],
      estado: false,
      estados: [
        {
          value: false,
          label: "Vigente",
        },
        {
          value: true,
          label: "Vencido",
        },
      ],
      editarFechasVisible: false,
      dialogVisible: false,
      editarVisible: false,
      isLoading: false,
      contracts: [],
      contract: {},
      bhpProfiles: {
        hse: "HSE",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("HSE Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente"),
        super: this.$t("Superintendente"),
        general_manager: this.$t("Gerente General"),
      },
      totalPage: 0,
      paginar: false,
      search: "",
      page: 1,
      loading: false,
    };
  },
  components: {
    ModificarContrato,
    Circle9,
  },
  watch: {
    search() {
      this.loading = true;
      this.debounceInputSearch();
    },
  },
  computed: {
    ...mapGetters({
      usersFaena: "usersFaena",
    }),
  },
  async created() {
    this.setSubTitle(this.$t("Administración de contratos"));
    this.listadoContratos(1, this.search);
    this.getAreasFaena();
    this.getEmpresasFaena();
    this.getUsersFaena(this.$store.getters.role.faena_id);
  },
  methods: {
    ...mapActions([
      "setSubTitle",
      "getUsersFaena",
      "getAreasFaena",
      "getEmpresasFaena",
      "saveContract",
    ]),
    setMandante() {
      this.listadoContratos(this.page, this.search);
    },
    setSubcontrato() {
      this.empresa_mandante = null;
      this.listadoContratos(this.page, this.search);
      if (this.subcontrato === true) {
        this.getSubcontratistas();
      }
    },
    async getSubcontratistas() {
      let response = await axios.post(
        `/contratos/getEmpresasSubcontratistas`,
        {
          faena_id: this.$store.getters.role.faena_id
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      this.subcontratistas = response.data;
    },
    debounceInputSearch: _.debounce(function () {
      this.page = 1;
      this.listadoContratos(this.page, this.search);
    }, 1200),
    resetListado() {
      this.setEstado();
    },
    setEstado() {
      this.page = 1;
      if (this.tipo === "Propio") {
        this.estado = false;
        this.subcontrato = false;
        this.empresa_mandante = null;
      }
      this.listadoContratos(this.page, this.search);
    },
    listadoContratos(page, search) {
      this.loading = true;
      const self = this;
      axios
        .get(
          `/contratos/getAllContracts/${this.$store.getters.role.faena_id}/${this.tipo
          }/${page}/${search === "" ? undefined : search}/${this.estado}/${this.subcontrato}/${this.empresa_mandante}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          self.contracts = response.data.results;
          self.totalPage = response.data.total;
          self.paginar = response.data.paginar;
          self.loading = false;
        });
    },
    paginarContratos() {
      return this.contracts.slice((this.page - 1) * 5, this.page * 5);
    },
    currentPage(page) {
      this.page = page;
      this.listadoContratos(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoContratos(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoContratos(page, this.search);
    },
    async updateContract() {
      this.isLoading = true;
      await this.saveEdit();
    },
    isActiveContract(contract) {
      if (contract.tipo_contrato === "Propio") {
        return true;
      }
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    handleClose() {
      this.editarVisible = false;
      this.editarFechasVisible = false;
    },
    elegirContrato(contrato) {
      this.contract = JSON.parse(JSON.stringify(contrato));
      this.editarVisible = true;
    },
    seleccionarContratoVigencia(contrato) {
      this.contract = JSON.parse(JSON.stringify(contrato));
      this.editarFechasVisible = true;
    },
    eliminarContrato(contrato) {
      this.$confirm(
        `Estás a punto de eliminar el contrato ${contrato.nombre}, ¿Estás seguro que deseas continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        var self = this;
        axios
          .post(
            `/contratos/delete_contract`,
            { _id: contrato._id, user: self.$store.getters.user._id },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response) => {
            if (response.data.success === true) {
              this.$notify.success({
                title: this.$t("Éxito"),
                message: this.$t(response.data.message),
              });
              self.listadoContratos(self.page, self.search);
            } else {
              this.$notify.error({
                title: this.$t("Error"),
                message: this.$t(response.data.message),
              });
            }
          });
      });
    },
    duplicarContrato(contrato) {
      this.$confirm(
        `Estás a punto de duplicar el contrato ${contrato.nombre}, ¿Estás seguro que deseas continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        var self = this;
        axios
          .post(
            `/contratos/duplicar`,
            { id: contrato._id },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response) => {
            if (response.data.status === true) {
              this.$notify.success({
                title: this.$t("Información"),
                message: this.$t(response.data.message),
              });
              self.listadoContratos(self.page, self.search);
            } else {
              this.$notify.error({
                title: this.$t("Error"),
                message:
                  "Ha ocurrido un error, contactese con el administrador de la plataforma.",
              });
            }
          });
      });
    },
    createContract() {
      this.$router.push({ name: "contractCreateStep1" });
    },
    async saveEdit() {
      const val = JSON.parse(JSON.stringify(this.contract));
      const id = this.contract._id;
      delete this.contract._id;
      this.$store
        .dispatch("editContract", {
          id,
          body: this.contract,
        })
        .then(async (response) => {
          if (response.success) {
            this.listadoContratos(this.page, this.search);
            this.$notify.success({
              title: this.$t("Éxito"),
              message: this.$t("Contrato editado exitosamente"),
            });
            this.handleClose();
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.$alert(response.message, this.$t("Atención"), {
              type: "error",
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.ver {
  cursor: pointer;
}

.right {
  text-align: right;
}

.search {
  max-width: 340px;
}

.content {
  min-height: 50vh;
}

.content_edit {
  padding: 10px;
}

.info {
  cursor: pointer;
}

.espacioTitulo {
  margin-bottom: 5px;
}

.title {
  padding-bottom: 10px;
}
</style>
